<template>
  <div class="big">
    <DocMsg
      :isFlag="doc_msg"
      :doctorId="doctorId"
    ></DocMsg>
    <div class="page_title">平台补贴/补扣记录</div>
    <div style="padding: 20px">
      <div class="container">
        <div class="searchbox">
          <div class="item">
            <span>医生姓名</span>
            <el-input
              placeholder="请输入"
              v-model="doctor_name"
              style="width: 120px; margin-left: 6px"
              @input="search"
              clearable
            ></el-input>
          </div>
          <div class="item">
            <span>医生手机</span>
            <el-input
              placeholder="请输入"
              v-model="phone"
              style="width: 120px; margin-left: 6px"
              clearable
              @input="search"
            ></el-input>
          </div>
          <div class="item">
            <span>医院</span>
            <el-input
              placeholder="请输入"
              v-model="hospital"
              style="width: 120px; margin-left: 6px"
              clearable
              @input="search"
            ></el-input>
          </div>
          <div class="item">
            <span>转入类型</span>
            <el-select
              v-model="account_type"
              placeholder="请选择"
              style="width: 140px; margin-left: 6px"
              clearable
              @change="search"
            >
              <el-option
                v-for="(item, index) in status_list"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="item">
            <span>转入时间</span>
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="~"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              clearable
              @change="search"
              style="width: 225px; margin-left: 6px"
            ></el-date-picker>
            <el-button
              type="info"
              size="medium"
              style="
                background-color: #eceff2;
                color: #747981;
                margin-left: 6px;
              "
              @click="search"
            >查询</el-button>
          </div>
        </div>
        <div style="text-align: right; margin-bottom: 10px; font-size: 15px">
          平台补贴/补扣总计：
          <span style="color: #fb8c1c">{{ total_money }}</span>
        </div>

        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              label="转入时间"
              prop="create_time"
            ></el-table-column>
            <el-table-column label="医生信息">
              <template slot-scope="scope">
                <div>
                  <span
                    @click="showDocMsg(scope.row.doctor_id)"
                    style="cursor:pointer"
                  >
                    {{ scope.row.doctor_name }}
                  </span>
                  <span style="margin-left: 10px">{{
                    scope.row.sex == 1 ? "男" : "女"
                  }}</span>
                </div>
                <div>{{ scope.row.phone }}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="医院"
              prop="hospital"
            ></el-table-column>
            <el-table-column
              label="平台补贴/补扣金额"
              prop="money"
            ></el-table-column>
            <el-table-column label="转入类型">
              <template slot-scope="scope">
                <span v-if="scope.row.account_type == 1">账户余额</span>
                <span v-if="scope.row.account_type == 2">可提现余额</span>
                <span v-if="scope.row.account_type == 3">不可提现余额</span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div style="margin-top: 24px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import DocMsg from '../../../components/common/DocMsg.vue';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      tableData: [],
      date: [],
      totalNum: 0,
      doctor_name: '',
      phone: '',
      hospital: '',
      account_type: '',
      status_list: [
        {
          label: '账户余额',
          value: 1
        },
        {
          label: '可提现余额',
          value: 2
        },
        {
          label: '不可提现余额',
          value: 3
        }
      ],
      total_money: 0,
      doc_msg: false,
      doctorId: ''
    };
  },
  components: {
    DocMsg
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    admin_id() {
      return this.$store.state.login.userInfo.admin_id;
    }
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        doctor_name: this.doctor_name,
        phone: this.phone,
        hospital: this.hospital,
        account_type: this.account_type
      };
      if (this.date && this.date.length > 0) {
        data.create_time_start = dayjs(this.date[0]).format('YYYY-MM-DD');
        data.create_time_end = dayjs(this.date[1]).format('YYYY-MM-DD');
      }
      this.axios
        .post('platform/Cost/getDoctorSubsidyPatchList', data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.create_time = dayjs
                .unix(item.create_time)
                .format('YYYY-MM-DD HH:mm');
              return item;
            });
            this.totalNum = res.data.total;
            this.total_money = res.data.total_money;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    //查看详情
    toDetail(consult_id) {
      this.$router.push({
        path: 'wenzhendetail',
        query: {
          consult_id
        }
      });
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  border-radius: 5px;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  .item {
    margin-right: 14px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
}
</style>
